import http from "@/settings/apiSettings"

class ParteneriDataService {
  save(data: any): Promise<any> {
    return http.clientComercialOdata.post("/PAR_Parteneri", data);
  }

  saveBank(data: any): Promise<any> {
    return http.clientComercialOdata.post("/PAR_BanciParteneri", data);
  }

  update(key: string, data: any): Promise<any> {
    return http.clientComercialOdata.patch(`/PAR_Parteneri(${key})`, data);
  }

}
export default new ParteneriDataService();